import { getAccessToken } from './tokenStore';

/**
 * Returns Authorization header with the current access token.
 *
 * Used as a fallback for browsers that block cross-origin cookies (e.g.
 * Safari ITP). Reads through tokenStore rather than localStorage directly,
 * so an in-memory token refreshed a moment ago is used immediately and there
 * is one place that decides where the token is kept.
 */
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
